// extracted by mini-css-extract-plugin
export default {"rules":"Rules_rules__spIdu","btns":"Rules_btns__i3bhy","btn-move":"Rules_btn-move__fDQRn"};